import React from "react";
import ChildProductCategory from "./NavigationChildProductCategory";

const ProductCategory = ({ items }) => {
  return (
    <>
      {items.map((item, index) => (
        <li
          className={`nav-item col-xxl-2 col-xl-3 col-lg-4 ${item.IsActive !== null && item.IsActive ? "active" : ""}`}
          key={index}
        >
        
          <ul className="nav-child">
            <li className="nav-item">
              <a className="btn d-flex" rel="nofollow" href={item.Url}>
                <img src={i18n.CdnHostName + item.ImageUrl + "?width=60"} width="60" height="60" alt={item.DisplayName} />
                <span>{item.DisplayName}</span>
              </a>
            </li>

            <ChildProductCategory items={item.Children} />
          </ul>
        </li>
      ))}
    </>
  );
};

export default ProductCategory;
